import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { CustomMaterialModule } from "../../customModules/app-material-module";
import { QuillModule } from "ngx-quill";

import { StaticFileManagerRoutingModule } from "./static-file-manager-routing.module";
import { BodyComponent } from "./components/body/body.component";
import { DocumentListComponent } from "./components/document-list/document-list.component";
import { DocumentEditComponent } from "./components/document-edit/document-edit.component";
import { VersionHistoryComponent } from "./components/version-history/version-history.component";
import { VersionViewComponent } from "./components/version-view/version-view.component";

@NgModule({
  declarations: [
    BodyComponent,
    DocumentListComponent,
    DocumentEditComponent,
    VersionHistoryComponent,
    VersionViewComponent
  ],
  imports: [
    CommonModule,
    StaticFileManagerRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    CustomMaterialModule,
    QuillModule
  ],
  providers: []
})
export class StaticFileManagerModule {}